// TODO: Migrate My Plans to Microapp

'use strict';
import {Component, Input, OnInit} from '@angular/core';
import {ServiceUsage, SubscriptionPlan, SubscriptionWithPaymentDetail} from '@ox/typings';
import {AppConfigService, AutoDestroy} from '@ox/utils';
import {ShopDataService} from '@webu/data';
import {Subject, takeUntil} from 'rxjs';
import {replaceVariable} from '@ox/utils';

@Component({
  selector: 'webu-subscriptions',
  templateUrl: './subscriptions.component.html'
})
export class SubscriptionsComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input () subscription: SubscriptionPlan;
  @Input () upcomingIndex: number;
  @Input () isTrialSecondItem : boolean;
  @Input () group : SubscriptionWithPaymentDetail;
  @Input () userRole : string;
  @Input () isFuture : boolean;
  @Input () isVehicleOverviewPage: boolean;
  @Input () serviceUsage: ServiceUsage;

  brand: string;
  vin: string;

  constructor(
    private shopDataService: ShopDataService,
    private appConfig: AppConfigService
  ) {}

  ngOnInit(): void {
    this.shopDataService.getCopyData().pipe(takeUntil(this.destroy$)).subscribe(() => {
    this.setData();
  });
  }

  setData() {
    this.brand = this.appConfig.bml.brand;
    this.brand = this.brand[0].toUpperCase() + this.brand.slice(1);
  }

  getPlanDescription(planCode: string) {
    const copy = this.shopDataService.getProductCopyByCode(planCode);
    if (copy)
      return replaceVariable(copy.description ?? '', {Brand: this.brand});
    else
      return '';
  }

  getPlanName(planCode: string) {
    const copy = this.shopDataService.getProductCopyByCode(planCode);
    return replaceVariable(copy?.displayName ?? '', {Brand: this.brand});
  }
}
